/**
 * Реестр SVG-иконок достижений и лояльности (design_handoff_achievements).
 * Файлы — stroke="currentColor" без собственных цветов: тир задаётся CSS
 * `color` на медальоне. Vite инлайнит через import.meta.glob('?raw').
 */
const rawAch = import.meta.glob('../../assets/achievements/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const rawLoyalty = import.meta.glob('../../assets/loyalty/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

function byId(map: Record<string, string>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(map).map(([path, svg]) => [
      path.replace(/^.*\/([^/]+)\.svg$/, '$1'),
      svg,
    ]),
  );
}

export const ACH_ICONS: Record<string, string> = byId(rawAch);
export const LOYALTY_ICONS: Record<string, string> = byId(rawLoyalty);

/** Иконка достижения по id из каталога; неизвестный id — пустой круг. */
export function AchIcon({ id, className }: { id: string | null; className?: string }) {
  const svg = id ? (ACH_ICONS[id] ?? LOYALTY_ICONS[id]) : undefined;
  if (!svg) return null;
  // Инлайн из собственного бандла (не пользовательский ввод) — безопасно.
  return (
    <span
      className={`ach-icon${className ? ` ${className}` : ''}`}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}

/** Щит очков достижений (K1/PF1), путь из хендоффа. */
export function ShieldIcon(_: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
      strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" />
    </svg>
  );
}
